import * as React from 'react';
import { Config } from '../helper';

function calcPercentage(earned, max) {
  if (!max) return 0;
  return Math.round((earned / max) * 100);
}

function PathwayCard({ pathway, index, percentage }) {
  const isCompleted = Config.IsCompleted(pathway.status);
  const ctaLabel = Config.I18n.Cta(pathway.status);

  return (
    <div className='card card--pathway'>
      {pathway.card_image_url && (
        <img src={pathway.card_image_url} alt={pathway.name} title={pathway.name}/>
      )}
      <div className='card__content'>
        <div className='card__progress'>
          <div className='card__progress-header'>
            <p className='card__progress-label text-bold mb-0'>{Config.I18n.Status(pathway.status)}</p>
            <div className='card__progress-value'>{percentage}%</div>
          </div>

          <div className='btn-group'>
            <div className='progress'>
              <div
                className='progress-bar'
                role='progressbar'
                style={{ width: `${percentage}%` }}
                aria-valuenow={percentage}
                aria-valuemin='0'
                aria-valuemax='100'
              />
            </div>
          </div>

          {isCompleted && pathway.completed_ago && (
            <div className='card__progress-status card__progress-finished'>
              {pathway.completed_ago}
            </div>
          )}

          {!isCompleted && pathway.estimated_time && (
            <div className='card__progress-status card__progress-eta'>
              {pathway.estimated_time}
            </div>
          )}
        </div>

        <div className='card__details'>
          <p className='card__details-eyebrow text-bold mb-0'>{Config.I18n.LessonNumber(index + 1)}</p>
          <h2 className='card__details-title h--smaller mb-0'>{pathway.name}</h2>
          {pathway.description && (
            <p
              className='card__details-description mb-0'
              dangerouslySetInnerHTML={{ __html: pathway.description }}
            />
          )}
        </div>

        {pathway.page_path && (
          <div className='card__actions'>
            <a
              className='nv-cta-secondary nv-cta-secondary--small'
              href={pathway.page_path}
              aria-label={`${ctaLabel}: ${pathway.name}`}
            >
              {ctaLabel}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default function Layout(props) {
  const {
    pathways,
    scores = {},
  } = props;

  return (
    <div className='container pathways-cards'>
      <div className='row'>
        <div className='col cards-grid'>
          {pathways.map((pathway, index) => {
            const { earned = 0, max = 0 } = scores[pathway.id] || {};
            return (
              <PathwayCard
                key={pathway.id}
                pathway={pathway}
                index={index}
                percentage={calcPercentage(earned, max)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
